module.exports = __webpack_public_path__ + "static/xometry-go-green-c5261fc39bd4f32b160ba81986ecf6f9.svg";